export const tsmtPitch = {
  hero: {
    title: "Hogyan adhat a Bespire új digitális növekedési réteget a TSMT® Modellnek?",
    subtitle: "Vezetői döntéselőkészítő áttekintés egy modern, skálázható képzési, tartalomértékesítési és szakemberközvetítési modellről",
    badges: {
      info: "Információs oldal",
      training: "Képzésértékesítés",
      digital: "Digitális tartalom",
      network: "Szakemberközvetítés",
    },
    mockupCards: {
      website: "Modern weboldal",
      booking: "Foglalási rendszer",
      courses: "Online kurzusok",
      profiles: "Szakemberprofilok",
    },
  },
  executiveSummary: {
    title: "Röviden: miért releváns ez a TSMT® számára?",
    subtitle: "A legfontosabb stratégiai megállapítások egy pillantásra",
    points: [
      {
        title: "Erős szakmai brand",
        description: "A TSMT® már most is erős szakmai brand és strukturált tudásrendszer — ez az alap, amire érdemes digitálisan építeni.",
      },
      {
        title: "Következő növekedési szint",
        description: "A következő növekedési szint a digitális élmény, az értékesítés és a hálózati működés fejlesztése lehet.",
      },
      {
        title: "Egységes rendszer",
        description: "A Bespire egyetlen rendszerben tudja kezelni a tartalmat, képzéseket, digitális termékeket és a szakember-ajánlási logikát.",
      },
      {
        title: "Hármas javulás",
        description: "Így egyszerre javulhat a felhasználói élmény, az adminisztráció hatékonysága és a bevételtermelő képesség.",
      },
      {
        title: "Fokozatos bevezetés",
        description: "Mindez fokozatosan, alacsony kockázattal, a meglévő működés megzavarása nélkül is bevezethető.",
      },
    ],
  },
  strengths: {
    title: "Erős szakmai alapok, erős brand, valós országos jelenlét",
    subtitle: "A TSMT® Modell kiemelkedő szakmai értékei, amelyekre érdemes digitálisan is építeni",
    items: [
      {
        title: "Szakmai módszertani háttér",
        description: "A TSMT® egyedülálló, tudományosan megalapozott módszertani keretrendszerrel rendelkezik, amely hazai és nemzetközi szinten is elismert.",
      },
      {
        title: "Kettős célcsoport-megszólítás",
        description: "A modell egyszerre szólítja meg a szülőket — akik gyermeküknek keresnek megoldást — és a szakembereket, akik a módszertant elsajátítanák.",
      },
      {
        title: "Strukturált képzési rendszer",
        description: "Többszintű képzési és továbbképzési rendszer, amely a TVTH minőségbiztosítási logikával 2024 júliusától tovább erősödik.",
      },
      {
        title: "Országos szakemberi hálózat",
        description: "Végzett terapeuták országszerte elérhetők, a szakemberi hálózat valós lefedettséget biztosít a szülők számára.",
      },
      {
        title: "Minőségbiztosítási logika",
        description: "A TVTH tagok tudásukat 5 évente megújítják, biztosítva a folyamatos szakmai színvonalat és a szülői bizalmat.",
      },
    ],
  },
  growthOpportunity: {
    title: "Hol rejtőzik a következő növekedési lehetőség?",
    subtitle: "Hat lépés, ahol a digitális működés közvetlenül bevételt és hatékonyságot teremt — az érdeklődéstől a visszatérő vásárlóig",
    funnel: [
      {
        from: "Információból",
        to: "konverzió",
        description: "A látogató ne csak olvasson, hanem lépjen is: jelentkezzen, kérdezzen, vásároljon.",
      },
      {
        from: "Érdeklődőből",
        to: "jelentkező",
        description: "Egyszerű, egyértelmű jelentkezési útvonal, amely nem igényel manuális egyeztetést.",
      },
      {
        from: "Jelentkezőből",
        to: "fizető résztvevő",
        description: "Integrált fizetéssel az érdeklődés azonnal vásárlássá alakulhat.",
      },
      {
        from: "Résztvevőből",
        to: "visszatérő vásárló",
        description: "Továbbképzések, digitális anyagok és zárt tartalmak révén a kapcsolat nem ér véget a képzéssel.",
      },
      {
        from: "Végzett szakemberből",
        to: "aktív hálózati tag",
        description: "A végzett terapeuta nem csak egy név az adatbázisban, hanem látható, elérhető, ajánlható szakember.",
      },
      {
        from: "Szakmai tartalomból",
        to: "ismétlődő digitális bevétel",
        description: "Az egyszer elkészített anyagok újra és újra értéket teremthetnek — digitális termékként, kurzusként, zárt tartalomként.",
      },
    ],
  },
  challenge: {
    title: "A tudás, a képzés, az adminisztráció és a hálózati működés gyakran külön rendszerekben él",
    subtitle: "Egy erős szakmai modell digitális skálázásának természetes kihívásai",
    items: [
      {
        title: "Széttagolt digitális élmény",
        description: "A tartalom, a jelentkezés, a fizetés és a szakemberi keresés különböző felületeken, eltérő élménnyel érhető el.",
      },
      {
        title: "Manuális adminisztráció",
        description: "A jelentkezések feldolgozása, visszaigazolások és emlékeztetők küldése gyakran manuális vagy félig automatizált folyamat.",
      },
      {
        title: "Nehézkes jelentkezési útvonal",
        description: "Az érdeklődőtől a fizető résztvevőig vezető út több lépésből, külön rendszerekből és egyeztetésekből állhat.",
      },
      {
        title: "Hiányzó automatizmusok",
        description: "Az emlékeztetők, visszaigazolások és utánkövetések automatizálása erőforrást és időt szabadítana fel.",
      },
      {
        title: "Digitális tartalmak monetizációja",
        description: "A meglévő szakmai tudás jelentős része csak információként elérhető, nem strukturált digitális termékként.",
      },
      {
        title: "Szakemberi hálózat láthatósága",
        description: "A végzett szakemberek elérhetősége és közvetíthetősége a jelenlegi digitális keretek között korlátozott lehet.",
      },
    ],
  },
  bespireRole: {
    title: "A Bespire mint egységes digitális működési réteg",
    subtitle: "A Bespire nem csak egy weboldalépítő — egy olyan egységes platform, amely képes összehangolni a szervezet teljes digitális működését",
    capabilities: [
      { title: "Publikus információs réteg", description: "Modern, mobilbarát weboldal a szervezet teljes tartalmával" },
      { title: "Értékesítési folyamatok", description: "Képzések, digitális termékek és szolgáltatások értékesítése egy helyen" },
      { title: "Foglalási és jelentkezési logika", description: "Integrált jelentkezési rendszer automatikus feldolgozással" },
      { title: "Online fizetés", description: "Biztonságos fizetési megoldás a teljes vásárlási folyamatba építve" },
      { title: "Automatikus emlékeztetők", description: "E-mail és értesítési automatizmusok a teljes felhasználói úton" },
      { title: "Felhasználói adminisztráció", description: "Résztvevők, jelentkezők és tagok kezelése egyetlen felületen" },
      { title: "Digitális tartalmak kiszolgálása", description: "Letölthető anyagok, videók és online kurzusok értékesítése" },
      { title: "Szakemberi közvetítés", description: "Profilok, kereshetőség és ajánlási logika a szakemberi hálózathoz" },
      { title: "Szülői admin felület", description: "A szülők saját felületen követhetik gyermekük haladását, foglalásait és előzményeit" },
      { title: "Terapeuta admin felület", description: "A terapeuták saját kezelőfelületen kezelhetik profiljukat, időpontjaikat és ügyfeleiket" },
      { title: "Önkiszolgáló fejlesztés (no-code)", description: "A szervezet saját maga alakíthatja és bővítheti digitális felületeit programozói tudás nélkül — gyorsabb reakcióidő, alacsonyabb költségek, teljes kontroll" },
      { title: "Marketing automatizáció", description: "AI-vezérelt kampánykezelés: social media posztok, email sorozatok, ügyfél-visszahívás és célzott kommunikáció automatikusan, egy chatfelületről" },
    ],
  },
  pillar1: {
    title: "A meglévő szakmai tartalom nem vész el — korszerűbb digitális formában működik tovább",
    subtitle: "1. pillér: Eredeti tartalom átemelése és információközlés",
    blocks: [
      {
        title: "Információs tartalom újraszervezése",
        description: "A jelenlegi, értékes szakmai és edukációs tartalom átültethető egy modernebb, könnyebben navigálható struktúrába — anélkül, hogy bármi elveszne.",
      },
      {
        title: "Célcsoport alapú belépési pontok",
        description: "A szülők, a leendő terapeuták és az érdeklődő szakemberek külön-külön, számukra releváns belépési ponton érhetik el a tartalmat.",
      },
      {
        title: "Erősebb konverziós útvonalak",
        description: "Az információs tartalom könnyebben vezethető tovább konkrét cselekvésre: jelentkezés, kapcsolatfelvétel, vásárlás.",
      },
      {
        title: "Modernebb digitális élmény",
        description: "Egységesebb, gyorsabb, mobilbarát felület, amely a TSMT® brandjét professzionális és korszerű formában jeleníti meg.",
      },
    ],
  },
  pillar2: {
    title: "A képzés nem csak tájékoztatható, hanem teljes folyamatában értékesíthető és menedzselhető",
    subtitle: "2. pillér: Képzések teljes körű értékesítése",
    participant: {
      title: "A résztvevő oldaláról",
      items: [
        "Könnyen áttekinthető képzésoldalak részletes információkkal",
        "Egyszerű, néhány kattintásos jelentkezési folyamat",
        "Azonnali online fizetési lehetőség",
        "Automatikus visszaigazolás és emlékeztetők",
        "Saját felhasználói fiók a képzési előzmények nyomon követésére",
      ],
    },
    organizer: {
      title: "A szervező oldaláról",
      items: [
        "Több képzés és célcsoport párhuzamos kezelése",
        "Automatikus jelentkezés-feldolgozás és visszaigazolás",
        "Szükséges adatok és információk strukturált gyűjtése",
        "Emlékeztetők automatikus kiküldése a képzés előtt",
        "Jelentősen kisebb adminisztratív teher és átláthatóbb működés",
      ],
    },
  },
  pillar3: {
    title: "A szakmai tudásból ismétlődő digitális bevételi réteg építhető",
    subtitle: "3. pillér: Digitális tartalmak értékesítése",
    intro: "Ugyanaz a tudás nemcsak információként, hanem strukturált digitális termékként is értéket teremthet — ismétlődő bevételi forrásként.",
    products: [
      { title: "Letölthető szakmai anyagok", description: "Módszertani összefoglalók, gyakorlati útmutatók PDF vagy e-book formában" },
      { title: "Szülői segédanyagok", description: "Otthoni gyakorlatokhoz, fejlesztési feladatokhoz készült segédletek" },
      { title: "Videós és moduláris anyagok", description: "Rövid oktatóvideók, képzésmodulok online elérhető formában" },
      { title: "Tudásfrissítő tartalmak", description: "A TVTH rendszerhez kapcsolódó, 5 évente megújítandó tudást támogató anyagok" },
      { title: "Zárt szakmai tartalmak", description: "Csak regisztrált szakemberek számára elérhető módszertani dokumentumok" },
      { title: "Előkészítő és utókövető anyagok", description: "Képzésekhez készült előzetes és utánkövető tananyagok a résztvevőknek" },
    ],
  },
  pillar4: {
    title: "A szakemberi hálózat nemcsak adatbázis, hanem aktív digitális szolgáltatási réteg lehet",
    subtitle: "4. pillér: Szakemberek közvetítése és láthatóvá tétele",
    features: [
      { title: "Terapeuta- és szakemberprofilok", description: "Részletes, megbízható profiloldalak minden végzett szakember számára" },
      { title: "Területi és szakterületi kereshetőség", description: "A szülők település, terület vagy szakterület alapján kereshetnek szakembert" },
      { title: "Bizalomerősítő megjelenítés", description: "Végzettség, tapasztalat és minőségbiztosítási státusz megjelenítése a profilon" },
      { title: "Kapcsolatfelvételi és ajánlási utak", description: "Egyszerű kapcsolatfelvétel, jelentkezés vagy időpontkérés közvetlenül a profilról" },
      { title: "A hálózat erősebb láthatósága", description: "A szakemberi hálózat egységes, professzionális digitális megjelenése" },
      { title: "Szülői igény és kínálat összekapcsolása", description: "Jobb összekapcsolás aközött, amit a szülők keresnek és amit a szakemberek kínálnak" },
    ],
  },
  businessValue: {
    title: "Az érték nem csak technológiai, hanem üzleti és működési is",
    subtitle: "A Bespire bevezetése három dimenzióban is mérhető előnyöket hozhat",
    columns: {
      revenue: {
        title: "Bevételi előnyök",
        items: [
          "Több fizető jelentkező a képzésekre",
          "Jobb konverzió az érdeklődésből vásárlásba",
          "Új, ismétlődő digitális bevételi láb",
          "Szélesebb elérés online értékesítéssel",
        ],
      },
      operations: {
        title: "Működési előnyök",
        items: [
          "Kisebb adminisztrációs terhelés",
          "Automatizált jelentkezési és fizetési folyamat",
          "Egységesebb, átláthatóbb működés",
          "Kevesebb manuális egyeztetés és utánkövetés",
        ],
      },
      brand: {
        title: "Márka- és hálózati előnyök",
        items: [
          "Modernebb, professzionálisabb márkaélmény",
          "Erősebb szakemberi hálózati jelenlét",
          "Jobb felhasználói út szülők és szakemberek számára",
          "A TSMT® brand digitális pozíciójának erősítése",
        ],
      },
    },
  },
  roadmap: {
    title: "Gyorsan bevezethető, azonnal értéket teremt",
    subtitle: "Nem kell hónapokig várni az eredményre — az első fázis akár 2-4 hét alatt élesíthető",
    phases: [
      {
        number: "1",
        title: "Információs és konverziós réteg",
        timeline: "2–4 hét",
        items: [
          "Meglévő szakmai tartalom átstrukturálása",
          "Új, célcsoport-specifikus landing oldalak",
          "Szülői és szakemberi belépési pontok szétválasztása",
          "CTA-k és konverziós útvonalak kiépítése",
        ],
      },
      {
        number: "2",
        title: "Képzési értékesítés és felhasználói adminisztráció",
        timeline: "+4–6 hét",
        items: [
          "Online jelentkezési és fizetési folyamat",
          "Automatikus visszaigazolások és emlékeztetők",
          "Felhasználói fiókok és képzési előzmények",
          "Adminisztratív folyamatok egyszerűsítése",
        ],
      },
      {
        number: "3",
        title: "Digitális tartalmak és szakemberi hálózat",
        timeline: "+6–8 hét",
        items: [
          "Digitális termékek és zárt tartalmak értékesítése",
          "Szakemberprofilok és keresési logika",
          "Közvetítési és ajánlási rendszer",
          "Teljes hálózati megjelenítés",
        ],
      },
    ],
  },
  whyNow: {
    title: "Miért lehet időszerű most meglépni ezt?",
    subtitle: "A digitalizáció nem nulláról indul — hanem egy meglévő, hiteles rendszer következő fejlődési lépcsője lehet",
    points: [
      {
        title: "A szakmai alap már megvan",
        description: "A TSMT® módszertani háttere, képzési rendszere és minőségbiztosítási logikája érett és strukturált.",
      },
      {
        title: "A brand már megvan",
        description: "A TSMT® országosan ismert és elismert brand — a digitális jelenlét ennek az erőnek az online kiterjesztése.",
      },
      {
        title: "A hálózat már megvan",
        description: "Végzett terapeuták, aktív szakemberek és szülői közösség — a hálózat él, csak a digitális réteg hiányzik.",
      },
      {
        title: "Az érdeklődői oldal már megvan",
        description: "Szülők és leendő terapeuták aktívan keresik a TSMT®-t — a kérdés az, milyen élményt kapnak érkezéskor.",
      },
      {
        title: "A következő lépés logikus",
        description: "Nem egy kockázatos váltásról van szó, hanem egy meglévő, működő rendszer természetes digitális továbbfejlesztéséről.",
      },
    ],
  },
  closing: {
    title: "A kérdés nem az, hogy van-e érték a TSMT®-ben — hanem az, hogyan lehet ezt digitálisan még jobban kibontani",
    message: "A Bespire segítségével a TSMT® egy olyan modernebb digitális működési modell felé léphet, amely:",
    benefits: [
      "Megtartja a szakmai hitelességet",
      "Javítja a felhasználói élményt",
      "Egyszerűsíti az adminisztrációt",
      "Új bevételi lehetőségeket nyit",
      "Erősíti a szakemberi hálózat láthatóságát",
    ],
    cta: {
      label: "Javasolt következő lépés",
      description: "Közös feltáró workshop a prioritások és a legjobb bevezetési modell meghatározására",
      button: "Workshop egyeztetése",
    },
  },
  therapistValue: {
    title: "Mit nyer egy terapeuta, ha a TSMT® a Bespire rendszerét használja?",
    subtitle: "A digitális fejlesztés nemcsak a szervezetnek előny, hanem a hálózatban dolgozó terapeuták számára is kézzelfogható értéket adhat",
    cards: [
      {
        title: "Láthatóság",
        items: [
          "Strukturált, egységes szakemberprofil",
          "Könnyebb megtalálhatóság a szülők és érdeklődők számára",
          "Bizalomerősítő megjelenés egy szakmailag erős rendszerben",
          "Földrajzi vagy szakterületi kereshetőség",
          "Átláthatóbb bemutatkozási lehetőség",
        ],
      },
      {
        title: "Megkeresések",
        items: [
          "A szülők könnyebben találnak megfelelő szakembert",
          "Strukturáltabban érkező érdeklődések",
          "Nem elszórt csatornákon keresztül kapott megkeresések",
          "Kiszámíthatóbb és rendezettebb kapcsolatfelvétel",
          "Ajánlási logika, ami összeköti az igényt a szakemberrel",
        ],
      },
      {
        title: "Egyszerűbb működés",
        items: [
          "Kevesebb manuális egyeztetés",
          "Átláthatóbb információkezelés",
          "Automatikus értesítések és emlékeztetők",
          "Egyszerűbb hozzáférés a releváns szakmai információkhoz",
          "Rendezettebb digitális környezet a mindennapokhoz",
        ],
      },
      {
        title: "Szakmai kapcsolódás",
        items: [
          "Szorosabb kapcsolódás a TSMT® szakmai ökoszisztémájához",
          "Könnyebb hozzáférés képzésekhez és tudásanyagokhoz",
          "Jobban követhető szakmai utak és lehetőségek",
          "Erősebb közösségi és hálózati élmény",
          "Modernebb, támogatóbb digitális háttér a szakmai jelenléthez",
        ],
      },
    ],
    summary: "A terapeuta szempontjából a Bespire-rel támogatott TSMT® rendszer nem pusztán egy új felület, hanem egy olyan digitális háttér, amely segítheti a láthatóságot, a kapcsolódást, az adminisztráció egyszerűsítését és a szakmai hálózatban való aktívabb jelenlétet.",
  },
  demo: {
    label: "Élő bemutató",
    title: "Már elkészült a továbbfejlesztett TSMT® oldal demója",
    description: "A jelenlegi tsmtmodell.hu oldal tartalmát átemeltük és továbbfejlesztettük egy modern, funkciókban gazdag platformmá — amely nem csupán tájékoztat, hanem értékesít, közvetít és automatizál.",
    features: [
      "Eredeti tartalom átemelve — teljes információközlés megmaradt",
      "Képzések értékesítése fizetéssel, emlékeztetőkkel és user adminnal",
      "Digitális tartalmak értékesítése",
      "Szakemberek közvetítése és keresése",
    ],
    cta: "Demo oldal megtekintése",
    note: "A demo a tsmtmodell.hu oldal továbbgondolt, bővített változata — így nézhet ki az éles rendszer.",
  },
};
